import React from "react";

export const FacilitiesContext = React.createContext([]);